import styled from '@emotion/styled'

export const StyleReportWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`
export const StyleConsultDateCard = styled.div`
  background: ${(props: any) => props.theme.colors.primary200};
  padding: 5px 10px;
  border-radius: 4px;
`
export const StyleReportItem = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  padding: 15px 10px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
  }
`
